// Ask again instead of waiting on one request.
//
// `attempt(n)` makes try number n (0, 1, 2 ...) and resolves to one of
//   { good: true, value }  the answer that was wanted
//   { final: true }        a real answer that is not it (the hub has no such villa): asking the
//                          same place again cannot change it
//   anything else, or a rejection: this try failed
//
// One try starts at once. If it is still silent after `hedgeAfterMs`, the next starts beside it,
// and the first good answer from any of them wins. A try that fails starts the next one straight
// away. At most `tries` are ever made.
//
// Resolves, never rejects: { answered, value, tries }. `answered` is false only when every try
// failed, which is the caller's cue that asking again later is worth it.
export const firstGoodAnswer = (attempt, { tries = 3, hedgeAfterMs = 1500 } = {}) =>
  new Promise((resolve) => {
    let started = 0;
    let pending = 0;
    let done = false;
    let timer = null;

    const finish = (answered, value) => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      resolve({ answered, value, tries: started });
    };

    const next = () => {
      if (done) return;
      if (started < tries) start();
      else if (pending === 0) finish(false, undefined);
    };

    const start = () => {
      if (done || started >= tries) return;
      const n = started;
      started += 1;
      pending += 1;
      clearTimeout(timer);
      if (started < tries) timer = setTimeout(start, hedgeAfterMs);
      Promise.resolve()
        .then(() => attempt(n))
        .then(
          (r) => {
            pending -= 1;
            if (r && r.good) finish(true, r.value);
            else if (r && r.final) finish(true, undefined);
            else next();
          },
          () => {
            pending -= 1;
            next();
          }
        );
    };

    start();
  });

export default firstGoodAnswer;
